import { siteConfig } from '~/data/config';

export interface LeadPayload {
  name?: string;
  phone: string;
  comment?: string;
  vehicle?: string;
  part?: string;
  vin?: string;
  photoName?: string;
  source?: string;
  // используются на странице Caterpillar 3412E
  company?: string;
  visitDate?: string;
  installment?: boolean;
}

export interface SubmitResult {
  ok: boolean;
  message?: string;
}

export async function submitLead(payload: LeadPayload): Promise<SubmitResult> {
  if (siteConfig.formEndpoint) {
    try {
      const res = await fetch(siteConfig.formEndpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });
      if (!res.ok) throw new Error(`Bad status: ${res.status}`);
      return { ok: true };
    } catch (e) {
      return { ok: false, message: e instanceof Error ? e.message : 'Ошибка отправки' };
    }
  }

  // Имитация — реальный API ещё не подключён
  await new Promise((r) => setTimeout(r, 1100));
  if (typeof window !== 'undefined') {
    console.info('[lead-stub] payload', payload);
  }
  return { ok: true };
}
